import filterFetchData from 'js/containers/Pages/Search/SearchFilter/fetchData';
import courseFetchData from 'js/containers/Pages/Search/SearchResults/Entities/Entity/Course/CourseFetchData';
import articleFetchData from 'js/containers/Pages/Search/SearchResults/Entities/Entity/Article/ArticleFetchData';
import manualFetchData from 'js/containers/Pages/Search/SearchResults/Entities/Entity/Manual/ManualFetchData';
import videoFetchData from 'js/containers/Pages/Search/SearchResults/Entities/Entity/Video/VideoFetchData';
import searchResultCountData from 'js/containers/Pages/Search/SearchResults/SearchResultsCount/SearchResultsCountData';
import MixPanelWrapper from 'js/servises/MixPanelWrapper';
import SearchStore from 'js/store/SearchStore';

class SearchService {
   async runSearch(apiPath, searchQuery, filterTaxData, filterEntitiesData, orderBy, searchPage, isAISearch) {
        const dotsReg = new RegExp('[.\\,\\_]+', 'g');
        const bracketsReg = new RegExp('[^ \\w]+', 'g');
        let filteredQuery = searchQuery.replace(dotsReg, '');
        filteredQuery = filteredQuery.replace(bracketsReg, ' ');

        return await fetch(`${apiPath}/graphql`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                query: `
					{
                        search {
                          ${filterFetchData(filterEntitiesData, filterTaxData)}
                          searchResult(query: "${isAISearch ? searchQuery : filteredQuery}", orderBy: "${orderBy}", page: ${searchPage}, aiSearch: ${SearchStore.isAISearch}) {
                            ${courseFetchData}
                            ${articleFetchData}
                            ${manualFetchData}
                            ${videoFetchData}
                          }
                          ${searchResultCountData}
                        }
                    }
				`
            })
        });
    }

    setPageViewEvent() {
        const {INIT_MIX_PANEL} = MixPanelWrapper || null;
        (async () => {
            if (!INIT_MIX_PANEL) {
                return;
            }
            await MixPanelWrapper.TrackPageView({
                page: 'Search'
            });
        })();
    }
    setSearchResultEvent(load, postsCount, isAISearch) {
        (async () => {
            if (!load) {
                return;
            }
            await MixPanelWrapper.TrackEvent(
                'Search Results count',
                {
                    category: 'Search Results',
                    value: `${postsCount}`,
                    searchType: isAISearch ? 'AI' : 'Regular'
                });
        })();
    }

    calculateWords(str:string) {
        let result = str.replace(/(^\s*)|(\s*$)/gi, '');
        result = result.replace(/[ ]{2,}/gi, ' ');
        result = result.replace(/\n /, '\n');
        return result.split(' ').length;
    }

    findChunksAtBeginningOfWords(textToHighlight, searchWords, sep) {
        const chunks = [];
        const textLow = textToHighlight.toLowerCase();
        const singleTextWords = textLow.split(sep);
        let fromIndex = 0;

        const singleTextWordsWithPos = singleTextWords?.map((s) => {
            const indexInWord = textLow?.indexOf(s, fromIndex);
            fromIndex = s?.length + indexInWord;
            return {
                word: s,
                index: indexInWord
            };
        });

        searchWords.forEach((sw) => {
            const swLow = sw.toLowerCase();
            singleTextWordsWithPos.forEach((s) => {
                if (s.word.startsWith(swLow)) {
                    const start = s.index;
                    const end = s.index + swLow.length;
                    chunks.push({
                        start,
                        end
                    });
                }
            });

            if (textLow.startsWith(swLow)) {
                const start = 0;
                const end = swLow.length;
                chunks.push({
                    start,
                    end
                });
            }
        });
        return chunks;
    };
}

export default new SearchService();
